export class Flavor {
	rating: String = '';
    flavor: String = '';
}



// WEBPACK FOOTER //
// ./src/app/flavor.ts